// @flow
/* globals document, window */
import React from "react";
import { render } from "react-dom";
import SellerLead from "./SellerLead";
//import SellerTestMap from "./SellerTestMap";

function renderApp(props) {
  const root = document.getElementById("react");
  if (root) {
    return render(<SellerLead {...props} />, root);
  }
}
renderApp(window.reactProps);
